const sceneManager = {
    "GameScene": "GameScene",
    "MenuScene": "MenuScene",
    "LostScene": "LostScene",
    "WinScene": "WinScene"
};

export default sceneManager;